<template>
  <div>
    <v-dialog v-model="eventoDialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card tile>
        <v-toolbar dense flat card dark color="primary">
          <v-btn @click.prevent="closeDialog()" icon dark>
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title v-if="mode == formModes.MODIFICA && evt.TipologiaEvento === 'Gara'">Modifica evento di Gara</v-toolbar-title>
          <v-toolbar-title v-else-if="mode == formModes.INSERIMENTO && evt.TipologiaEvento === 'Gara'">Nuovo evento di Gara</v-toolbar-title>
          <v-toolbar-title v-else-if="mode == formModes.VISUALIZZAZIONE && evt.TipologiaEvento === 'Gara'">Visualizza evento di Gara</v-toolbar-title>

          <v-toolbar-title v-if="mode == formModes.MODIFICA && evt.TipologiaEvento === 'Formazione'">Modifica evento di Formazione</v-toolbar-title>
          <v-toolbar-title v-else-if="mode == formModes.INSERIMENTO && evt.TipologiaEvento === 'Formazione'">Nuovo evento di Formazione</v-toolbar-title>
          <v-toolbar-title v-else-if="mode == formModes.VISUALIZZAZIONE && evt.TipologiaEvento === 'Formazione'">Visualizza evento di Formazione</v-toolbar-title>

          <v-toolbar-title v-if="mode == formModes.MODIFICA && evt.TipologiaEvento === 'Didattico'">Modifica evento Didattico</v-toolbar-title>
          <v-toolbar-title v-else-if="mode == formModes.INSERIMENTO && evt.TipologiaEvento === 'Didattico'">Nuovo evento Didattico</v-toolbar-title>
          <v-toolbar-title v-else-if="mode == formModes.VISUALIZZAZIONE && evt.TipologiaEvento === 'Didattico'">Visualizza evento Didattico</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-toolbar-items>
            <v-btn v-if="evt.id && mode == formModes.MODIFICA" :disabled="!valid" @click="aggiornaEventoDialog(evt)" flat>
              <v-icon dark left>save</v-icon>
              Aggiorna
            </v-btn>
            <v-btn v-else-if="(mode == formModes.INSERIMENTO)" :disabled="!valid" @click="salvaEvento(evt)" flat>
              <v-icon dark left>save</v-icon>
              Salva
            </v-btn>
            <v-btn @click.prevent="closeDialog()" flat>
              <v-icon dark left>undo</v-icon>
              Annulla
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-md text-xs-center>
            <v-form ref="form" v-model="valid" lazy-validation>
              <campi-evento :evt.sync="evt" :image.sync="image" :prop-form-mode.sync="mode" :email-default.sync="emailDefault"></campi-evento>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAggiorna" persistent max-width="700" style="margin: auto;">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Attenzione</v-card-title>
        <v-card-text class="headline">Modificando la data della gara l'evento deve essere riapprovato dall'amministratore </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogAggiorna = false" ma-auto color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="aggiornaEvento(evt)" ma-0 color="accent white--text" dark> <v-icon small left>check</v-icon>aggiorna evento </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import CampiEvento from '../generale/CampiEvento';
  import { mapGetters, mapActions } from 'vuex';
  import { bus } from '@/main';
  import Security from '@/security';
  import Util from '@/util';
  import AssociazioneEntity from '../../anagrafica/associazioni/AssociazioneEntity';
  import EventoEntity from '../generale/EventoEntity';

  export default {
    components: { CampiEvento },
    props: ['evt', 'dtEvt', 'image', 'propFormMode', 'tipologiaEvento', 'objFormazione', 'objDidattico', 'dataIniziale'],
    data() {
      return {
        Util,
        emailChanged: '',
        IndoorChangd: false,
        isUpdated: false,
        eventoDialog: false,
        dialogAggiorna: false,
        mode: this.propFormMode,
        elencoFunzioni: Security.enFunzione,
        formModes: Util.enFormMode,
        ruoli: Security.ruolo,
        valid: false,
      };
    },
    computed: {
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters(['userData']),
      ...mapGetters('sharedModule', ['getAnniSportivi']),

      maxAnnoSportivo() {
        var idAnnoSportivo;
        idAnnoSportivo = Math.max(...this.getAnniSportivi.map((item) => item.id));
        return idAnnoSportivo;
      },

      emailDefault() {
        if (this.mode == this.formModes.INSERIMENTO) {
          if (this.evt.TipologiaEvento === 'Gara' && this.evt.id == null && this.isAdmin) {
            return '';
          }
          return this.userData.Denominazione;
        } else return this.evt.EmailRiferimento;
      },
      formatEvt() {
        let dataEvt = null;
        dataEvt = new Date(this.dtEvt).toISOString().substr(0, 10);
        return dataEvt;
      },
      formatNewData() {
        let newData = null;
        newData = new Date(this.evt.DataEvento).toISOString().substr(0, 10);
        return newData;
      },
      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },
    },
    watch: {
      propFormMode() {
        this.mode = this.propFormMode;
      },
    },
    created() {
      const vm = this;
      bus.$on('eventoDialog', function (value) {
        vm.eventoDialog = value;
      });
      bus.$on('emailDefaultChange', function (value) {
        vm.updateTitle(value);
      });
    },
    methods: {
      ...mapActions('eventiModule', ['createEvento', 'updateEvento']),
      closeDialog() {
        this.$emit('reset-elm');
        bus.$emit('eventoDialog', false);
      },
      salvaEvento(item) {
        if(item.NumeroPostiTotali != 0){
          item.NumeroPostiTotali = parseInt(item.NumeroPostiTotali, 10)
        }
        if (item.TipologiaEvento === 'Gara') {
          if (item.TipoEvento.Codice.includes('IBO')) {
            item.ClassificazioneEvento = 'Europeo';
            item.isIndoor = this.IndoorChangd;
            item.tipologiaEvento = 'Gara';
          }
        } else if (item.TipologiaEvento === 'Formazione') {
          item.TipoEvento = this.objFormazione;
          item.isOpen = true;
          item.ClassificazioneEvento = 'Formazione';
        } else if (item.TipologiaEvento === 'Didattico') {
          item.TipoEvento = this.objDidattico;
          item.isOpen = true;
          item.isAttivo = true;
          item.ClassificazioneEvento = 'Didattico';
        }
        if (this.emailChanged === '') {
          item.EmailRiferimento = this.emailDefault;
        } else {
          item.EmailRiferimento = this.emailChanged;
        }
        /*
        if (this.evt.TipologiaEvento === 'Gara' && this.isUpdated == false) {
          item.EmailRiferimento = this.emailDefault;
        } else if (this.evt.TipologiaEvento === 'Gara' && this.isUpdated == false) {
          item.EmailRiferimento = this.emailChanged;
        } else {
          item.EmailRiferimento = this.emailDefault;
        }
*/
        this.createEvento({ item: item, annoSportivo: this.maxAnnoSportivo });
      },
      aggiornaEventoDialog(evt) {
        const vm = this;
        if (!this.isAdmin && this.formatEvt != this.formatNewData) {
          vm.dialogAggiorna = true;
        } else {
          this.aggiornaEvento(evt);
        }
      },
      aggiornaEvento(evt) {
        if(evt.NumeroPostiTotali != 0){
          evt.NumeroPostiTotali = parseInt(evt.NumeroPostiTotali, 10)
        }
        if (this.emailChanged === '') {
          evt.EmailRiferimento = this.emailDefault;
        } else {
          evt.EmailRiferimento = this.emailChanged;
        }
        this.evt.isIndoor = this.IndoorChangd;

        if (!this.isAdmin && this.formatEvt != this.formatNewData) {
          evt.isAttivo = false;
        }
        if (evt.InvioScore === false) {
          evt.DataInvioScore = null;
        }
        this.updateEvento({ editItem: evt, annoSportivo: this.maxAnnoSportivo });
        this.dialogAggiorna = false;
      },
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      checkFormMode(insertMode) {
        if (
          insertMode &&
          (Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_EVENTO, this.userData.Role) ||
            Security.isAbilitata(this.elencoFunzioni.INSERIMENTOEVENTO_ASSOCIAZIONE, this.userData.Role))
        ) {
          this.mode = this.formModes.INSERIMENTO;
          return this.formModes.INSERIMENTO;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO, this.userData.Role)) {
          this.mode = this.formModes.MODIFICA;
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO_ASSOCIAZIONE, this.userData.Role)) {
          this.mode = this.formModes.MODIFICA;
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.VISUALIZZAZIONE_EVENTO, this.userData.Role)) {
          this.mode = this.formModes.VISUALIZZAZIONE;
          return this.formModes.VISUALIZZAZIONE;
        }
      },
      updateTitle(t) {
        this.emailChanged = t;
        this.isUpdated = true;
      },
    },
  };
</script>
<style>
  .v-input__icon--append .fa-asterisk {
    font-size: 1rem;
  }
</style>
